import type { XYData, XYChartOptions, SeriesOptions } from '../../types.js';

export function getSeriesOpts(name: string, options: XYChartOptions): SeriesOptions {
  const wildcard = options.series?.['*'] ?? {};
  const named = options.series?.[name] ?? {};
  return { ...wildcard, ...named };
}

export function getYAxisCount(data: XYData, options: XYChartOptions): number {
  let count = 1;
  if (options.series) {
    for (const s of data.series) {
      const so = getSeriesOpts(s.name, options);
      if (so.yAxisIndex !== undefined && so.yAxisIndex + 1 > count) {
        count = so.yAxisIndex + 1;
      }
    }
  }
  return count;
}

export function applyMarkLines(series: Record<string, unknown>, so: SeriesOptions): void {
  if (!so.markLines || so.markLines.length === 0) return;
  series.markLine = {
    symbol: ['none', 'none'],
    data: so.markLines.map((type) => ({
      type,
      name: type.charAt(0).toUpperCase() + type.slice(1),
      label: {
        position: 'start',
        align: 'right',
        verticalAlign: 'middle',
        distance: 8,
      },
    })),
  };
}

export function applyMarkPoints(series: Record<string, unknown>, so: SeriesOptions): void {
  if (!so.markPoints || so.markPoints.length === 0) return;
  series.markPoint = {
    data: so.markPoints.map((type) => ({
      type,
      name: type.charAt(0).toUpperCase() + type.slice(1),
    })),
  };
}
